@if (initialized) {


  <div class=" flex-column flex-auto overflow-auto" style="height: calc(100vh - 9rem); display: grid;">
    <div class="surface-card lg:p-4 p-0 shadow-2 border-round text-left">
      <div class="flex flex-column md:flex-row w-full justify-content-between md:align-items-center">
        <div class="lg:p-0 p-4">

          <!--          TICKET: 1000000700-->
          <h2 class="mt-0 mb-2 text-900 font-medium text-2xl">
            {{ (settingService.header$ | async)?.header }}
          </h2>
          <p class="mt-0 mb-0 text-500">
            {{ (settingService.header$ | async)?.subHeader }}
          </p>
        </div>
      </div>
      <p-divider styleClass="lg:mb-5 mb-2 lg:mt-4 mt-0"></p-divider>

      <div class="">

        <div class="md:p-6 p-4">

          <!-- ROUTER -->
          <router-outlet/>

        </div>
      </div>


    </div>
  </div>

}
